// extracted by mini-css-extract-plugin
module.exports = {"custom-filter":"styles_custom-filter__167wQ"};